function rooms_Reducer(state = [], action) {
    switch (action.type) {
        case 'ROOMS/SET':            
            return action.rooms;
        case 'ROOMS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default rooms_Reducer;
